/**
 * Wraps an async function so calls sharing the same key reuse one
 * in-flight promise instead of each starting a new request. A key
 * gets a fresh call again once its previous one has settled.
 */
export function singleFlight<TArg, TResult>(
    fn: (arg: TArg) => Promise<TResult>,
    getKey: (arg: TArg) => string
): (arg: TArg) => Promise<TResult> {
    const pending = new Map<string, Promise<TResult>>();

    return (arg: TArg) => {
        const key = getKey(arg);
        if (pending.has(key)) {
            return pending.get(key)!;
        }

        const promise = fn(arg).finally(() => pending.delete(key));
        pending.set(key, promise);
        return promise;
    };
}
